var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-subscription';
                    var viewUrl = 'sprite.svg#view-icon-subscription';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };